let MainContainer = Vue.component('main-container', {
	data() {
		return {
			isScrolling: this.$root.$store.state.isScrolling,
			scrollTarget: 0
		}
	},
	computed: {
		pushFixHeight() {
			if (this.$root.$store.state.isScrolling) {
				return {
					height: this.$refs['main'].clientHeight + 'px'
				}
			} else {
				return {
					height: '0px'
				}
			}
		},
		styles() {
			if (this.$root.$store.state.isScrolling) {
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop
				return {
					position: 'fixed',
					top: - scrollTop + 'px',
					transform: 'translate3d(0,' + (- this.scrollTarget + scrollTop) + 'px,0)',
					transition: 'transform 1s cubic-bezier(0.77, 0, 0.175, 1)'
				}
			} else {
				return {
					position: 'relative',
					transform: 'none',
					top: 'auto'
				}
			}
		},
		classes() {
			return {
				'main--intro': this.$root.$store.state.loopHelper.isIntro,
				'main--padding-fix': this.$root.$store.state.isScrolling,
				'main--fade-out': this.$root.$store.state.loopHelper.dismissOutro,
				'main--fade-sections': this.$root.$store.state.loopHelper.fixOutro
			}
		}
	},
	watch: {
		isScrolling() {
			console.log('changed!')
		}
	},
	methods: {
		scrollTo(pos, callback) {
			this.$root.$store.commit('isScrolling', true)
			this.scrollTarget = pos
			$(this.$el).children('#main').one('transitionend', () => {
				this.$root.$store.commit('isScrolling', false)
				if (callback) callback()
				window.scrollTo(0, pos) // !!
			})
		}
	},
	template: `
		<div>
			<main id="main" ref="main" :class="classes" :style="styles">
				<slot></slot>
			</main>
			<div class="pushfix" :style="pushFixHeight"></div>
		</div>`
})

export default MainContainer
